import { createFileRoute, redirect } from '@tanstack/react-router'

import { getOutletId } from '@/lib/auth'

export const Route = createFileRoute('/_app/outlet')({
  loader: () => {
    if (!getOutletId()) throw redirect({ to: '/' })
    return {
      crumb: 'Outlet',
    }
  },
})
